import {Injectable} from "@angular/core";
import {ServiceConfig} from "../app/services-config";
import {AuthorizedService} from "./authorized.service";
import {ResourceService} from "./resource.service";

@Injectable()
export class AppointmentService extends ResourceService {
  constructor(private authorizedService: AuthorizedService) {
    super(authorizedService, ServiceConfig.appointment.listUrl, ServiceConfig.appointment.detailUrl);
  }

  /**
   * get all appointments by code
   * @param code
   * @returns {Observable<R>}
   */
  getByCode(code) {
    return this.authorizedService.get(ServiceConfig.appointment.codeListUrl.replace("{code}", code)).map(data => {
      return data.json()
    });
  }

  /**
   * schedule an appointment
   * @param formData
   * @returns {Observable<R>}
   */
  scheduleAppointment(formData) {
    return this.authorizedService.post(ServiceConfig.appointment.schedule, formData).map(data => {
      return data;
    });
  }
}



// WEBPACK FOOTER //
// ./src/services/appointment.service.ts